import {
  Text,
  VStack,
  HStack,
  FormControl,
  FormLabel,
  Input,
  RadioGroup,
  Radio,
  Box,
} from '@chakra-ui/react';

import Card from 'components/card/Card';
import { useAppSelector, useAppDispatch } from 'hooks';
import {
  setHasTelematics,
  setTelematicsDriverName,
  setTelematicsPhone,
  setTelematicsEmail,
  useLegacyAutoFormLocked,
} from 'reducers/legacyAutoFormReducer';

const TelematicsSection = () => {
  const dispatch = useAppDispatch();
  const isLocked = useLegacyAutoFormLocked();

  const hasTelematics = useAppSelector(
    (state) => state.legacyAutoForm.data.telematics.has_telematics,
  );
  const telematicsDriverName = useAppSelector(
    (state) => state.legacyAutoForm.data.telematics.driver_name,
  );
  const telematicsPhone = useAppSelector(
    (state) => state.legacyAutoForm.data.telematics.phone,
  );
  const telematicsEmail = useAppSelector(
    (state) => state.legacyAutoForm.data.telematics.email,
  );

  const handleHasTelematicsChange = (value: string) => {
    dispatch(setHasTelematics(value === 'yes'));
  };

  const handleDriverNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(setTelematicsDriverName(event.target.value));
  };

  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setTelematicsPhone(event.target.value));
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setTelematicsEmail(event.target.value));
  };

  return (
    <Card mb="20px" id="sectionTelematics">
      <Text fontWeight="bold" fontSize="2xl" mb="20px">
        Telematics Data
      </Text>

      <VStack spacing={4} align="stretch">
        <FormControl>
          <FormLabel ml="0">Does the risk use telematics?</FormLabel>
          <RadioGroup
            value={hasTelematics ? 'yes' : 'no'}
            onChange={handleHasTelematicsChange}
            isDisabled={isLocked}
          >
            <HStack spacing={8}>
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </HStack>
          </RadioGroup>
        </FormControl>

        {hasTelematics && (
          <Box p={4} borderWidth="1px" borderRadius="md" borderColor="gray.200">
            <Text fontWeight="medium" mb={4}>
              Driver Enrolled in Telematics
            </Text>
            <VStack spacing={4} align="stretch">
              <FormControl>
                <FormLabel ml="0">Name</FormLabel>
                <Input
                  variant="main"
                  value={telematicsDriverName}
                  onChange={handleDriverNameChange}
                  placeholder="Enter driver name"
                  isDisabled={isLocked}
                />
              </FormControl>

              <HStack spacing={4}>
                <FormControl flex={1}>
                  <FormLabel ml="0">Cell Phone Number</FormLabel>
                  <Input
                    variant="main"
                    type="tel"
                    value={telematicsPhone}
                    onChange={handlePhoneChange}
                    placeholder="Enter phone number"
                    isDisabled={isLocked}
                  />
                </FormControl>

                <FormControl flex={1}>
                  <FormLabel ml="0">Email</FormLabel>
                  <Input
                    variant="main"
                    type="email"
                    value={telematicsEmail}
                    onChange={handleEmailChange}
                    placeholder="Enter email address"
                    isDisabled={isLocked}
                  />
                </FormControl>
              </HStack>
            </VStack>
          </Box>
        )}
      </VStack>
    </Card>
  );
};

export default TelematicsSection;
